import { render, staticRenderFns } from "./AbschnittUeberMich.vue?vue&type=template&id=cf415410&"
import script from "./AbschnittUeberMich.vue?vue&type=script&lang=js&"
export * from "./AbschnittUeberMich.vue?vue&type=script&lang=js&"
import style0 from "./AbschnittUeberMich.vue?vue&type=style&index=0&id=cf415410&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports